module.exports = __webpack_public_path__ + "media/cases-brand-chinamobile-lazyload-121.5a614bf4.mp4";